import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';

import { PageSkeleton } from '~/components/common/page-skeleton/page-skeleton';

// Super-admin gating is inherited from the parent `/platform` route's
// `requireSystemAdmin()` beforeLoad — no additional guard needed here.
const EnrichmentLimitsPage = lazy(() => import('~/features/platform/pages/enrichment-limits-page'));

export const Route = createFileRoute('/_authenticated/_tenant/platform/enrichment-limit')({
  component: () => (
    <Suspense fallback={<PageSkeleton />}>
      <EnrichmentLimitsPage />
    </Suspense>
  ),
});
